function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrayarrowdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3h-15A1.5 1.5 0 003 4.5v15A1.5 1.5 0 004.5 21h15a1.5 1.5 0 001.5-1.5v-15A1.5 1.5 0 0019.5 3zm0 1.5v9.75h-2.69a1.486 1.486 0 00-1.06.44l-1.81 1.81h-3.88l-1.81-1.81a1.487 1.487 0 00-1.06-.44H4.5V4.5h15zm0 15h-15v-3.75h2.69L9 17.56a1.487 1.487 0 001.06.44h3.88a1.487 1.487 0 001.06-.44l1.81-1.81h2.69v3.75zM8.47 11.78a.75.75 0 111.06-1.06l1.72 1.72V6.75a.75.75 0 111.5 0v5.69l1.72-1.72a.75.75 0 111.06 1.06l-3 3a.747.747 0 01-1.06 0l-3-3z",
    fill: props.fill
  }));
}

export default SvgTrayarrowdown;